import * as React from 'react';
import { EmployeeTableChart } from '../../../interface/MyInterfaces';
import * as Helpers from '../../Common/Helpers';

export class EmployeeTable extends React.Component<EmployeeTableChart, {}> {
    render() {
        var occList;
        if (this.props.SpendingEmployeeTable !== undefined) {
                occList = this.props.SpendingEmployeeTable.map(function (table, index) {
                var outlier = Helpers.outlier(table.avg, table.std, table.pct);

                return <tr key={index}><td className={"color" + outlier.toString()}>{table.occ}</td>
                    <td className={"color" + outlier.toString()}>{table.pct}%</td>
                    <td className={"color" + outlier.toString()}>{table.avg}% ± {table.std}%</td>
                </tr>;
            })
        }

        return <table className="table employeetable">
            <thead><tr><th style={{ width:"50%" }}>Occupational Category</th>
                <th style={{ width: "20%" }}>University Percentage</th>
                <th style={{ width: "30%" }}>Benchmark Mean ± Std</th>
            </tr></thead>
                <tbody>
                    {occList}
                </tbody>
            </table>
    }
}